import { AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';

function isEmptyInputValue(value: any): boolean {
  return value == null || value.length === 0;
}
/**
 * Validator that requires controls to have a value of a minimum length without white spaces.
 * @param minLength
 */

export function MinLengthNotBlank(minLength?: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (isEmptyInputValue(control.value)) {
      return null;
    }
    const length: number = control.value ? control.value.trim().length : 0;
    return (length < (minLength ? minLength : 1)) ? { 'minlength': { 'requiredLength': minLength, 'actualLength': length } } : null;
  }
}
